module.exports = __webpack_public_path__ + "img/icon-basicEduS-38.81e19651.png";